import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";
import MKAlert from "components/MKAlert";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";
import MKDatePicker from "components/MKDatePicker";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/examples/blog-9-4.jpg";
//import bgImage1 from "assets/images/examples/content-2.jpg";

//icons
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import CategoryIcon from "@mui/icons-material/Category";
import LanguageIcon from "@mui/icons-material/Language";
import TodayIcon from "@mui/icons-material/Today";
import EventIcon from "@mui/icons-material/Event";
import CommentIcon from "@mui/icons-material/Comment";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

//motion
import { motion } from "framer-motion";

function Employer() {
  // server from env
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  //vars declaration
  const [alertMsg, setAlertMsg] = useState("");
  const [names, setNames] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [message, setMessage] = useState("");
  const [languages, setLanguages] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isBooked, setIsBooked] = useState(false);
  const [services, setServices] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);

  //--- function to handle submit ---
  const handleBooking = (e) => {
    e.preventDefault();

    setIsLoading(true);
    setIsBooked(false);

    const data = JSON.stringify({
      names: names,
      email: email,
      phone: phone,
      address: address,
      startDate: startDate,
      endDate: endDate,
      language: languages,
      service: services,
      message: message,
    });

    axios
      .post(`${SERVER_URL}/employer/add/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data === "Booked") {
          //window.scrollTo({ top: 0, behavior: "smooth" });
          setAlertMsg("Email Sent!, We'll Get Back to You Very Soon");
          setIsBooked(true);
        } else {
          //window.scrollTo({ top: 0, behavior: "smooth" });
          alert("BYANZE, Booking Yawe");
        }
      })
      .catch((err) => {
        //window.scrollTo({ top: 0, behavior: "smooth" });
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // languages
  useEffect(() => {
    axios
      .get(`${SERVER_URL}/helper/get-language/`)
      .then((res) => {
        if (res.status === 200) {
          setLanguageOptions(res.data);
        }
      })
      .catch((err) => console.error("Error fetching languages:", err));
  }, []);

  // service
  useEffect(() => {
    axios
      .get(`${SERVER_URL}/helper/get-service/`)
      .then((res) => setServiceOptions(res.data))
      .catch((err) => console.error("Error fetching services:", err));
  }, []);

  return (
    <>
      <>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/booking",
            label: "BOOK NOW",
            color: "info",
          }}
          transparent
          light
        />
        <MKBox
          minHeight="50vh"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        >
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={8}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={{ mx: "auto", textAlign: "center" }}
            >
              <MKTypography
                variant="h2"
                color="white"
                mb={2}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Discover Comfort and Convenience
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <Card
          sx={{
            p: { xs: 2, md: 4 },
            mx: { xs: 1, md: 4 },
            mt: -8,
            mb: 4,
            borderRadius: "2rem",
            backgroundColor: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(25px) saturate(200%)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          }}
        >
          <MKBox component="section" py={{ xs: 4, lg: 6 }}>
            <Container>
              {/* Booking Form */}
              <Card
                sx={{
                  p: { xs: 2, md: 4 },
                  mx: { xs: 1, md: 4 },
                  mt: -8,
                  borderRadius: "2rem",
                  backgroundColor: "rgba(255,255,255,0.85)",
                  backdropFilter: "blur(25px) saturate(200%)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                }}
              >
                <MKBox component="form" onSubmit={handleBooking}>
                  {alertMsg.length > 0 && (
                    <motion.div
                      initial={{ x: -200, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ duration: 1.5, ease: "easeOut" }}
                    >
                      <MKAlert color="info">{alertMsg}</MKAlert>
                    </motion.div>
                  )}
                  <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <MKTypography variant="h3" fontWeight="medium">
                      Book a Service
                    </MKTypography>

                    <MKTypography
                      component={Link} // Use React Router Link
                      to="/employee"
                      variant="body2"
                      sx={{
                        textDecoration: "underlinea",
                        textUnderlineOffset: "3px",
                        textDecorationColor: "#700808",
                        color: "#700808",
                        fontWeight: 500,
                        cursor: "pointer",
                        "&:hover": {
                          opacity: 0.8,
                          textDecorationColor: "#700808",
                        },
                      }}
                    >
                      Need a Job instead?
                    </MKTypography>
                  </MKBox>
                  <MKTypography variant="body2" mb={4} color="text.secondary">
                    Tailored Services for Every Traveler — From Arrival to Departure, We&apos;ve Got
                    You Covered
                  </MKTypography>

                  <Grid container spacing={3}>
                    {/* Full Name + Email */}
                    <Grid item xs={12} md={6}>
                      <MKInput
                        onChange={(e) => setNames(e.target.value)}
                        variant="outlined"
                        label="Full Name"
                        placeholder="Enter your full name"
                        size="large"
                        fullWidth
                        startAdornment={<PersonIcon sx={{ mr: 1, color: "gray" }} />}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        onChange={(e) => setEmail(e.target.value)}
                        variant="outlined"
                        label="Email"
                        placeholder="Enter your email"
                        size="large"
                        fullWidth
                        startAdornment={<EmailIcon sx={{ mr: 1, color: "gray" }} />}
                      />
                    </Grid>

                    {/* Telephone + Address */}
                    <Grid item xs={12} md={6}>
                      <MKInput
                        onChange={(e) => setPhone(e.target.value)}
                        variant="outlined"
                        label="Telephone"
                        placeholder="Enter phone"
                        size="large"
                        fullWidth
                        startAdornment={<PhoneIcon sx={{ mr: 1, color: "gray" }} />}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        onChange={(e) => setAddress(e.target.value)}
                        variant="outlined"
                        label="Address"
                        placeholder="Enter address"
                        size="large"
                        fullWidth
                        startAdornment={<LocationOnIcon sx={{ mr: 1, color: "gray" }} />}
                      />
                    </Grid>

                    {/* Select Service + Preferred Language */}
                    <Grid item xs={12} md={6}>
                      <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                        <CategoryIcon sx={{ mr: 1 }} /> Select Service
                      </MKTypography>
                      <Autocomplete
                        multiple
                        options={serviceOptions}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, value) =>
                          setServices(value.map((v) => ({ id: v.id, name: v.name })))
                        }
                        renderInput={(params) => <MKInput {...params} variant="outlined" />}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                        <LanguageIcon sx={{ mr: 1 }} /> Preferred Language
                      </MKTypography>
                      <Autocomplete
                        multiple
                        options={languageOptions}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, value) =>
                          setLanguages(value.map((v) => ({ id: v.id, name: v.name })))
                        }
                        renderInput={(params) => <MKInput {...params} variant="outlined" />}
                      />
                    </Grid>
                    {/* Start Date + End Date */}
                    <Grid item xs={12} md={6}>
                      <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                        <TodayIcon sx={{ mr: 1 }} /> Start Date
                      </MKTypography>
                      <MKDatePicker
                        variant="standard"
                        input={{ placeholder: "Select start date" }}
                        fullWidth
                        onChange={(date) => setStartDate(date[0])}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKTypography variant="button" mb={1} display="flex" alignItems="center">
                        <EventIcon sx={{ mr: 1 }} /> End Date
                      </MKTypography>
                      <MKDatePicker
                        variant="standard"
                        input={{ placeholder: "Select end date" }}
                        fullWidth
                        onChange={(date) => setEndDate(date[0])}
                      />
                    </Grid>

                    {/* Description */}
                    <Grid item xs={12}>
                      <MKInput
                        onChange={(e) => setMessage(e.target.value)}
                        variant="outlined"
                        label="Other Comments"
                        placeholder="Enter comments"
                        fullWidth
                        multiline
                        rows={5}
                        startAdornment={<CommentIcon sx={{ mr: 1, color: "gray" }} />}
                      />
                    </Grid>

                    {/* Submit Button Centered */}
                    <Grid item xs={12} display="flex" justifyContent="center">
                      <MKButton
                        variant="gradient"
                        color={isBooked ? "info" : "primary"}
                        type="submit"
                        disabled={isLoading || isBooked}
                      >
                        {isLoading ? "Sending Request..." : isBooked ? "Booked" : "Book Now"}
                      </MKButton>
                    </Grid>
                  </Grid>
                </MKBox>
              </Card>

              {/* Contact Section with 3 columns on desktop */}
              <Card
                sx={{
                  p: { xs: 3, md: 5 },
                  mx: { xs: 1, md: 4 },
                  my: 4,
                  borderRadius: "2rem",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  backdropFilter: "blur(25px) saturate(200%)",
                  boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                }}
              >
                <MKBox display="flex" flexDirection="column" alignItems="center">
                  <MKTypography variant="h4" mb={4} fontWeight="medium" textAlign="center">
                    Other Ways to Reach Us
                  </MKTypography>

                  <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} md={4}>
                      <MKBox
                        display="flex"
                        alignItems="center"
                        gap={2}
                        p={2}
                        borderRadius="1rem"
                        sx={{ backgroundColor: "rgb(255, 255, 255)", justifyContent: "center" }}
                      >
                        <PhoneIcon sx={{ fontSize: "1.5rem", color: "#700808" }} />
                        <MKTypography>(+250) 795 305 418</MKTypography>
                      </MKBox>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <MKBox
                        display="flex"
                        alignItems="center"
                        gap={2}
                        p={2}
                        borderRadius="1rem"
                        sx={{ backgroundColor: "rgb(255, 255, 255)", justifyContent: "center" }}
                      >
                        <EmailIcon sx={{ fontSize: "1.5rem", color: "#700808" }} />
                        <MKTypography>
                          info@helpereverywhere.com
                          <br />
                          helpereverywheremail@gmail.com
                        </MKTypography>
                      </MKBox>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <MKBox
                        display="flex"
                        alignItems="center"
                        gap={2}
                        p={2}
                        borderRadius="1rem"
                        sx={{ backgroundColor: "rgb(255, 255, 255)", justifyContent: "center" }}
                      >
                        <LocationOnIcon sx={{ fontSize: "1.5rem", color: "#700808" }} />
                        <MKTypography>KG 314 St, Kigali, Rwanda</MKTypography>
                      </MKBox>
                    </Grid>
                  </Grid>

                  {/* Social Buttons */}
                  <MKBox display="flex" justifyContent="center" gap={2} mt={4}>
                    <MKButton
                      variant="text"
                      color="primary"
                      iconOnly
                      component="a"
                      href="https://wa.me/250795305418"
                      target="_blank"
                    >
                      <WhatsAppIcon sx={{ fontSize: "1.5rem" }} />
                    </MKButton>
                    <MKButton
                      variant="text"
                      color="primary"
                      iconOnly
                      component="a"
                      href="https://facebook.com/helpereverywhere"
                      target="_blank"
                    >
                      <FacebookIcon sx={{ fontSize: "1.5rem" }} />
                    </MKButton>
                    <MKButton
                      variant="text"
                      color="primary"
                      iconOnly
                      component="a"
                      href="https://instagram.com/helpereverywhere"
                      target="_blank"
                    >
                      <InstagramIcon sx={{ fontSize: "1.5rem" }} />
                    </MKButton>
                  </MKBox>
                </MKBox>
              </Card>
            </Container>
          </MKBox>
        </Card>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </>
    </>
  );
}

export default Employer;
